import React from 'react'
import TrashIcon from '../../../../../components/Icon/Trash'
import MoneyIcon from '../../../../../components/Icon/Money'
import OrcamentoIcon from '../../../../../components/Icon/OrcamentoIcon'
import InativarIcon from '../../../../../components/Icon/InativarIcon'
import AtivaIcon from '../../../../../components/Icon/AtivaIcon'
import AgendaIcon from '../../../../../components/Icon/Agenda'

export const menuOpcoesPopper = ({data, whitelabel, mostrarOpcoes, functions }) => {
  const { status, faturado, tipo } = data;

  const is3dpe = whitelabel?.nome === "_3DPE";

  const labelFaturar = faturado ? 'Ver faturamento' : 'Faturar';

  const handleCallCurrentFunction = (functionName) => {
    if (functionName) {
      functionName(data)
      functions.closePopper()
    }
  };

  const optionsMenu = [
    {
      ativo: status !== "PENDENTE" || tipo === "ODONTOLOGICO",
      icon: <OrcamentoIcon size='20' color='#505050' />,
      label: 'Ver orçamento',
      onClick: () => handleCallCurrentFunction(functions?.handleClickVisualizar),
    },
    {
      ativo: status === "APROVADO",
      icon: <AgendaIcon size='20' color='#505050' />,
      label: 'Agendamento Sala',
      onClick: () => handleCallCurrentFunction(functions?.handleOpenAgendamentoSala),
    },
    {
      ativo: status === "APROVADO",
      icon: <AgendaIcon size='20' color='#505050' />,
      label: 'Agendamento',
      onClick: () => handleCallCurrentFunction(functions?.handleOpenAgendamento),
    },
    ...(status !== "INATIVO" ? 
      [{
        ativo: is3dpe && !faturado,
        icon: <InativarIcon size='20' color='#505050' />,
        label: 'Inativar',
        onClick: () => handleCallCurrentFunction(functions?.handleInativar),
      }] : []
    ),
     ...(status === "INATIVO" && is3dpe ? 
      [{
        ativo: is3dpe && !faturado,
        icon: <AtivaIcon size='20' color='#505050' />,
        label: 'Ativar',
        onClick: () => handleCallCurrentFunction(functions?.handleAtivar),
      }] : []
    ),
    
    ...(mostrarOpcoes || tipo !== "ODONTOLOGICO"? [
      {
        ativo: status === "APROVADO",
        icon: <MoneyIcon size='20' color='#505050' />,
        label: labelFaturar,
        onClick: () => handleCallCurrentFunction(functions?.handleFaturar),
      },
      {
        ativo: status === "PENDENTE",
        icon: <TrashIcon size='20' color='#505050' />,
        label: 'Excluir',
        onClick: () => handleCallCurrentFunction(functions?.handleExcluir),
      }
    ]:[])
  
  ]
  return optionsMenu
}
